<template>
  <SwapMenu2 swapid="ALL" :period="period" margin="2" :title="maptitle">
    <template v-slot:menu>
      <li> 
         <a v-for="item in maptab" :key=item.id
            class="dropdown-item" @click="changepage(item.id)">{{item.title}}</a>
         <a v-if="interval == 0" 
            class="dropdown-item" @click="start_interval()">Start Interval</a>
         <a v-if="interval > 0"
            class="dropdown-item" @click="stop_interval()">Stop Interval</a>
      </li>
    </template>
  </SwapMenu2>
  <div class="scroll01 cdefault">
    <canvas width=270 height=550 @click="showinfo()" @mousemove="showsymbol($event)" :id="'map' + globid"></canvas>
  </div>
  <div class="topleft">
      <table>
        <tr><td align=left>X</td><td>:</td><td align=left>{{posX}}</td></tr>
        <tr><td align=left>Y</td><td>:</td><td align=left>{{posY}}</td></tr>
        <tr><td align=left>Pos</td><td>:</td><td align=left>{{node.loc}}</td></tr>
        <tr><td align=left>Line</td><td>:</td><td align=left>{{node.pswline}}</td></tr>
        <tr><td align=left>Tag</td><td>:</td><td align=left>{{node.tag}}</td></tr>
        <tr><td align=left>send</td><td>:</td><td align=left>{{txdata.send}}</td></tr>
        <tr><td align=left>recv</td><td>:</td><td align=left>{{txdata.recv}}</td></tr>
        <tr><td align=left>totseq</td><td>:</td><td align=left>{{totseq}}</td></tr>
      </table>
  </div>
</template>

<style scoped>
.scroll01 {
  display : flex;
  justify-content : center ;
  align-items : center ;
  background-color: white;
  width: 100%;
  height: 600px ;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.topleft {
  font-size: 10pt;
  color : grey ;
  width : 100px ;
  height: 100px ;
  top : -550px ;
  display: inline-block ;
  position : relative ;
}
.cpointer {
  cursor : pointer ;
}
.cdefault {
  cursor : default ;
}
.canpos {
  width : 52rem ;
  height : 250px ;
  top    : 40px  ;
  left   : 50px ;
  position : absolute ;
}
</style>
<script>
import SwapMenu2 from './SwapMenu2.vue' 

let swapmap = null ;
let mapvar = {
   ctx : null,
   topX : 23,
   topY : 23
} ;

var getAbsPosition = function(el){
    var el2 = el;
    var curtop = 0;
    var curleft = 0;
    if (document.getElementById || document.all) {
        do  {
            curleft += el.offsetLeft-el.scrollLeft;
            curtop += el.offsetTop-el.scrollTop;
            el = el.offsetParent;
            el2 = el2.parentNode;
            while (el2 != el) {
                curleft -= el2.scrollLeft;
                curtop -= el2.scrollTop;
                el2 = el2.parentNode;
            }
        } while (el.offsetParent);

    } else if (document.layers) {
        curtop += el.y;
        curleft += el.x;
    }
    return [curtop, curleft];
};

let emptynode = { loc : "", tag : "", "pswline" : 0 } ;

export default {
  name: 'SwapMap',
  components : {
      SwapMenu2
  },
  props: {
    period : Number,
    screensize : String,
    mapid: String
  },
  data() {
    return {
        interval : 0, 
        posX : 0,
        posY : 0,
        offsetX : 0,
        offsetY : 0,
        node : emptynode,
        brokenedges : [ ]   // array off normalize edge string loc.loc
    }
  },
  watch : {
    totseq : function () {
        this.drawmap() ;
    }
  },
  computed : {
      widthclass() {
        if (this.screensize.length == 3)
            return this.screensize.substr(2) ;
        else return "1" ;
      },
      heightclass() {
        if (this.screensize.length == 3)
            return this.screensize.substr(0,1) ;
        else return "1" ;
     },
    controllerid() {
        return this.$store.getters.controllerid ;
    },
    canvasid() { return "map" + this.globid ; },
    totseq () {
      return this.$store.getters.totseq ;
    },
    txdata() {
        if ( ! this.node )
            return { "send" : 0, "recv" : 0 } 
        let swap = this.$store.getters.getswap_byid(this.node.pswline) ;
        if (! swap || ! swap.sdata || ! swap.sdata.txdata) 
            return { "send" : 0, "recv" : 0 } 

        return { "send" : swap.sdata.txdata.totinc,
                 "recv" :  swap.sdata.txdata.totout 
        }
    },
    swapmaps() {
        return this.$store.state.swapmaps ;
    },
    maptab() {
       let maps = this.swapmaps ;
       if (! maps) return [ { "id" : 0, "title" : "NO MAP" } ] ;
       let res = [] ;
       for (let i = 0 ; i < maps.length ; i++) {
          res.push( { id : i, "title" : maps[i].title } ) ;
       }
       return res;
    },
    pagenum() {
        return this.$store.state.curmappage ;
    },
    maptitle() {
        let maps = this.swapmaps ;
        if (maps) 
            return maps[this.pagenum].title ;
        else return "NO MAP" ;
    }
  },
  mounted() {
    if (this.mapid != "0")
        this.$store.commit("changemapid", this.mapid) ;
    this.start_interval();
    this.drawmap() ;
  },
  unmounted() {
    this.stop_interval();
  },
  methods : {
     stop_interval() {
         if (this.interval) {
            clearInterval(this.interval) ;
            this.interval = 0 ;
         }
     },
     start_interval() {
         if (this.interval == 0) {
            this.interval = setInterval( () => 
             { 
               if (! this.swapmaps ) this.$store.commit("get_swapmaps") ; 
               this.$store.commit("getswapdata") ; 
             }, this.period) ;
         }
     },
     myEventHandler() {
        let canvas = document.getElementById(this.canvasid);
        if (canvas) {
          let pos = getAbsPosition(canvas) ;
          this.offsetX = pos[1] ; 
          this.offsetY = pos[0] ;
        }
     },
     showinfo() {
        if (! document.getElementById("IFRAME01")) 
            return ;
        if (this.node && this.node.pswline != 0)  
            this.$store.state.rootel.swapinfo(this.node.pswline) ;
     },
     showsymbol(event) {
        if (! event.clientX || ! swapmap) 
            return ;

        let canvas = document.getElementById(this.canvasid) ;
        this.posX = event.clientX - this.offsetX ;
        this.posY = event.clientY - this.offsetY ;
        for (let i = 0 ; i < swapmap.length ; i++) {
            let node = swapmap[i] ;
            if (this.inrect(this.posX, this.posY, node.loc)) {
                this.node = node ;
                canvas.classList.remove("dpointer");
                canvas.classList.add("cpointer");
                return ;
            }
        }
        this.node = emptynode ;
        canvas.classList.remove("cpointer");
        canvas.classList.add("dpointer");
     },
     changepage(newpage) {
        this.$store.commit ("changemap", newpage) ;
        this.drawmap();
     },
     cmap ( cord ) {     // cord 7 x 5   11 ... 17, ... , 51 ... 57
        let s = cord ;

        if (typeof cord == "number") 
           s = cord.toString() ;
        else if (typeof cord != "string" )
           s = "11" ;

        let y = parseInt(s.substr(0,1))
        let x = parseInt(s.substr(1)) 
        x = (x - 1)  * 50 + mapvar.topX ;
        y = (y - 1)  * 90  + mapvar.topY ;
        return { "X" : x, "Y" : y } ;
     },
     drawcircle(cord, radius) {
        let pos = this.cmap(cord);
        mapvar.ctx.save() ;
        mapvar.ctx.translate (pos.X, pos.Y) ;
        mapvar.ctx.beginPath();
        mapvar.ctx.arc(0, 0, radius, 0, Math.PI * 2);
        mapvar.ctx.lineWidth = 2 ;
        mapvar.ctx.fillStyle = "#0000FF" ;
        mapvar.ctx.strokeStyle = "#8b8b8b" ;
        mapvar.ctx.fill();
        mapvar.ctx.restore() ;
     },
     inrect(curX, curY, loc) {
        let coord = this.cmap(loc) ;
        if ((curX > coord.X - 20 && curX < coord.X + 20) &&
            (curY > coord.Y - 20 && curY < coord.Y + 20) )
            return true ;
        return false ;
     },
     drawrect(loc, color) {
        mapvar.ctx.fillStyle = color ;
        let coord = this.cmap(loc) ;
        mapvar.ctx.fillRect(coord.X - 20, coord.Y - 20, 40, 40);
     },
     drawLine (fromLoc, toLoc) {
        let from = this.cmap(fromLoc) ;
        let to = this.cmap(toLoc) ;
        mapvar.ctx.beginPath();
        mapvar.ctx.moveTo(from.X, from.Y) ;
        mapvar.ctx.lineTo(to.X, to.Y);
        mapvar.ctx.strokeStyle = "#000000" ;
        mapvar.ctx.lineWidth = 2 ;
        mapvar.ctx.stroke();
        mapvar.ctx.closePath();
     },
     drawLineX (fromLoc, toLoc) {
        let from = this.cmap(fromLoc) ;
        let to = this.cmap(toLoc) ;
        if (fromLoc > toLoc) {
            let tmp = from ;
            from = to ;
            to = tmp ;
        }
        let broke1 = { X:0, Y:0} ;
        let broke2 = { X:0, Y:0}

        mapvar.ctx.beginPath();
        mapvar.ctx.moveTo(from.X, from.Y) ;

        broke1.X = to.X - (to.X - from.X) * 0.5;
        broke1.Y = to.Y - (to.Y - from.Y) * 0.5;

        mapvar.ctx.lineTo(broke1.X, broke1.Y) ;
        mapvar.ctx.strokeStyle = "#000000" ;
        mapvar.ctx.lineWidth = 2 ;
        mapvar.ctx.stroke();
        mapvar.ctx.closePath();

        broke2.X = to.X - (to.X - from.X) * 0.45;
        broke2.Y = to.Y - (to.Y - from.Y) * 0.45;

        mapvar.ctx.beginPath();
        mapvar.ctx.moveTo(broke2.X, broke2.Y) ;
        mapvar.ctx.lineTo(to.X, to.Y);
        mapvar.ctx.strokeStyle = "#000000" ;
        mapvar.ctx.lineWidth = 2 ;
        mapvar.ctx.stroke();
        mapvar.ctx.closePath();

        mapvar.ctx.font = "italic 10pt Arial" ;
        mapvar.ctx.fillStyle = "#FF0000" ;
        mapvar.ctx.fillText("X", broke1.X, broke1.Y + 5) ;
     },
     writetext( loc, mytext) {
        let cord = this.cmap(loc) ;
        mapvar.ctx.font = "italic 10pt Arial" ;
        mapvar.ctx.fillStyle = "#000000" ;
        let adj = mytext.length  * 4 ;
        mapvar.ctx.fillText(mytext, cord.X - adj, cord.Y + 5 );
     },
     drawmap() {
        let canvas = document.getElementById(this.canvasid) ;
        mapvar.ctx = canvas.getContext('2d');

        if (! this.swapmaps) 
            return;
        this.offsetX = 0;
        this.offsetY = 0 ;
        if (canvas) {
            let pos = getAbsPosition(canvas) ;
            this.offsetX = pos[1] ; 
            this.offsetY = pos[0] ;
        }
        window.addEventListener("resize", this.myEventHandler);
        let map = this.swapmaps[this.pagenum] ;
        if (map.options && map.options.indexOf("layout") != -1) {
            swapmap = null ;
            this.drawmap1(); 
        }
        else  {
            this.drawmap0(map) ;
        }
     },
     drawmap0(map) {
        swapmap = map.map ;
        mapvar.ctx.clearRect(0, 0, 300, 600);
        for (let i = 0 ; i < swapmap.length ; i++) {
            let node = swapmap[i] ;
            let edges, e, typex;
            if (node.edges.length > 0) {    // [[ loc, log], .... ]], or single
                typex = typeof (node.edges[0]) ;

                if (typex != "object")
                    edges = [ node.edges ] ;
                else
                    edges = node.edges ;

                for (let y = 0 ; y < edges.length ; y++) {
                    e = edges[y] ; // single pair item (to,log)
                    if (typeof e[1] == "undefined") e[1] = 0 ;

                    if ( this.isbroken_edge(node.pswline, e[1]) )
                        this.drawLineX (node.loc, e[0]) ;
                    else
                        this.drawLine (node.loc, e[0]) ;
                }
            }
        }
        for (let i = 0 ; i < swapmap.length ; i++) {
            let node = swapmap[i] ;
            if (node.pswline == 0) 
               this.drawrect( node.loc, "#B0B0B0") ;
            else if (this.isswap_down(node.pswline))
               this.drawrect( node.loc, "#FF2020") ;
            else
               this.drawrect( node.loc, "#B0A0F0") ;
            if (! node.disptag) 
               this.writetext( node.loc, (node.pswline) ? 
                        node.pswline.toString() : node.tag.substr(0,4) ) ;
            else
               this.writetext( node.loc, (node.tag) ? 
                        node.tag.substr(0,4) : node.pswline.toString() ) ; 
        }
     },
     normalize_edge(loc1, loc2) {
        let full_loc ;
        let sloc1, sloc2 ;

        sloc1 = loc1 ;
        sloc2 = loc2 ;
        if (typeof loc1 == "number")
            sloc1 = loc1.toString() ;

        if (typeof loc2 == "number")
            sloc2 = loc2.toString() ;

        if (sloc1 > sloc2) 
            full_loc = sloc2 + '.' + sloc1 ;
        else
            full_loc = sloc1 + '.' + sloc2 ;
        return full_loc ;
     },
     isswap_down(pswline) {
        let swap = this.$store.getters.getswap_byid( parseInt(pswline)) ;
        if (! swap) return 1;
        if ( ! swap["speedo"] ) return 1 ;
        return 0 ;
     },
     isbroken_edge(pswline, logaddr) {
        // let normal_edge = this.normalize_edge(loc1, loc2) ;
        let swap = this.$store.getters.getswap_byid( parseInt(pswline)) ;
        if (! swap) return 1 ;
        if (typeof swap.sdata == "undefined") return 1 ;
        if (swap.sdata.RC != "00") return 1 ;

        let conns = swap.sdata.logaddr ;
        let c = conns.find ( (obj) => { return (obj.a == logaddr ) } )  ;
        if (! c) return 1 ;
        if (c.s == 0) return 2 ; // no logon
        return 0 ;
     },
     drawmap1() {
        mapvar.ctx.clearRect(0, 0, 850, 250);

        this.drawLine("43", "41") ;
        this.drawcircle ("43",40) ;
        for (let x = 1 ; x < 8 ; x++) 
            for (let y = 1 ; y < 6 ; y++)  {
                let pos = x.toString() + y.toString() ;
                this.drawrect( pos, "#A0A0F0") ;
                this.writetext( pos, pos ) ;
            }
     }
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>

